export default __webpack_public_path__ + "static/media/lap.8eb7805b.jpg";